<template>
  <v-card v-bind="$attrs" @click="goFlowPreview(devInfo)">
    <v-list three-line subheader style="padding-bottom: 0">
      <v-list-item
        style="min-height: 54px; padding: 0 8px 0 11px; position: relative"
      >
        <v-list-item-avatar style="border-radius: 0">
          <DeviceIconImage :dev-info="devInfo" :size="40" />
        </v-list-item-avatar>
        <v-list-item-content style="padding: 0px">
          <v-list-item-title style="min-height: 1.6rem">
            <!-- <PriorityLabel :value="orderInfo.GZ_PRIORITY" /> -->
            <v-row no-gutters style="width: 100%">
              <v-col :cols="9">
                <span
                  style="
                    overflow: auto;
                    overflow-wrap: break-word;
                    white-space: normal;
                    width: 100%;
                    color: #616161;
                    font-size: 0.91rem;
                    display: inline-block;
                    padding-top: 0.33rem;
                  "
                >
                  {{ devInfo.DEV_TEXT }}
                </span>
              </v-col>
              <v-col
                :cols="3"
                style="
                  text-align: right;
                  padding-top: 0.101rem;
                  padding-right: 0.3rem;
                "
              >
                <span style="font-size: 0.78rem">
                  <DeviceStateText :dev-info="devInfo" :off-line="offLine" :show-off-line="false"/>
                  <i
                    class="fa fa-angle-right"
                    style="margin-left: 0.3rem; color: #9e9e9e"
                    aria-hidden="true"
                  ></i>
                </span>
              </v-col>
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
        <span
          style="
            position: absolute;
            top: 0.2rem;
            left: 0.5em;
            color: #9e9e9e;
            font-size: 0.75rem;
          "
          >{{ idx }}</span
        >
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import DeviceStateText from '../../Device/components/DeviceStateText';
import DeviceIconImage from '../../Device/components/DeviceIconImage';
export default {
  components: {
    DeviceStateText,
    DeviceIconImage
  },
  props: {
    devInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    devProp: {
      type: Object,
      default: () => {
        return {};
      }
    },
    idx: {
      type: Number,
      default: 0
    },
    offLine: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  mounted() {},
  created() {},
  methods: {
    goFlowPreview(item) {
      var that = this;
      if (item.SECURER_SID != 2) {
        that.$toast.warning('设备不在线')
        return
      }

      if (item.CUR_SID != 2 && item.DEV_SWITCH != 2) {
        that.$toast.warning('设备不在线')
        return
      }

      that.$router.goPage({
        path: '/FlowPreview',
        query: { iot_id: item.IOT_ID }
      });
    }
  }
};
</script>

<style scoped>
.s {
  position: relative;
}
</style>
